export default "__VITE_ASSET__eBXMr_3e__"